import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { goToTop } from '_helpers';
import ListItem from './ListItem';

const routes = {
  'event-list': (pathname) => ((pathname.includes('/wgw')) ? '/wgw/event-details' : '/cal/event-details'),
  'depo-list': (pathname) => ((pathname.includes('/wgw')) ? '/wgw/depo-details' : '/cal/depo-details'),
  'drop-event-list': (pathname) => ((pathname.includes('/wgw')) ? '/wgw/event-details' : '/cal/event-details'),
};

/**
 * import styles
 */
const Container = styled.div`
  width: 100%;
  height: 100%;
  background-color: #fff;
  max-width: 577px;
  margin: 30px auto;
  padding: 0 15px;
  box-sizing: border-box;
`;

const MoreLocationsList = ({ state, normaList = [] }) => {
  const history = useHistory();
  const { pathname } = useLocation();

  const detailsClickHandler = (item, kind) => {
    goToTop();
    const depoEventId = (kind.includes('event')) ? `${item.id}-${item.drop_event_loc_id}` : item.id;
    const depoEventKind = (kind.includes('event')) ? 'event-details' : 'depo-details';
    history.push(routes[kind](pathname), { id: depoEventId, depoEventKind });
  };

  return (
    <Container>
      {
        normaList
          .map((item) => (
            <ListItem
              key={item.key}
              title={item.name}
              itemKey={item.key}
              details={item.display_addr}
              itemClickHandler={() => detailsClickHandler(item, state.type)}
              detailsClickHandler={() => detailsClickHandler(item, state.type)}
            />
          ))
      }
    </Container>
  );
};

export default MoreLocationsList;
